/** Tiny classname joiner - filters falsy, joins with spaces. No deps. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
